import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

export const listQuery = gql`
  query fetchList($id: Long!) {
    list(id: $id) {
      name
      id
      size
    }
  }
`;

export const useListById = (id: number) => {
  const { data } = useGraphql(listQuery, {
    skip: !id,
    variables: { id },
  });

  const result = data?.list;

  return result;
};
